<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="text-h6 primary white--text">
          Escolha o ano do relatório
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="text-center mb-4">Selecione um ano</p>

          <v-row v-if="anosList.length > 0" no-gutters>
            <v-col cols="3" v-for="ano in anosList" :key="ano.id" class="pa-1">
              <v-btn block outlined color="secondary" @click="gerarRelatorio(ano)">
                {{ ano.descricao }}
              </v-btn>
            </v-col>
          </v-row>

          <p v-else class="text-center">Nenhum ano disponível</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="fechar()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      anosList: [],
    };
  },
  watch: {
    dialog: {
      async handler(newVal) {
        if (newVal) {
          await this.carregarAnos();
        }
      },
    },
  },
  methods: {
    async carregarAnos() {
      try {
        this.anosList = await this.$services.anosService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async gerarRelatorio(ano) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoAlunosMatriculados(ano.id);
        this.fechar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fechar() {
      this.$emit("dialogChange", false);
    },
  },
};
</script>
